import { render } from "./paginationInfoComponent.vue?vue&type=template&id=86669064"
import script from "./paginationInfoComponent.vue?vue&type=script&lang=js"
export * from "./paginationInfoComponent.vue?vue&type=script&lang=js"

import exportComponent from "F:\\CS\\Projectsdatabases\\madienty-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__